import PostFilter from '../classes/postFilter';
//import SelfAssessment from '../classes/selfAssessment';
export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    // 
    //let $assessmentStep = $('.assessment-step');
    let $nextStep = $('.assessment-step-btn.step-next');
    let $prevStep = $('.assessment-step-btn.step-prev');
    let $stepListItem = $('.steps-list span');
    let $assessmentBar = $('.assessment-bar');
    var currStepObj;

    let $container = $('.container-assessment > .container');

    let matchHeightOptions = {
      byRow: true,
      property: 'height', 
      target: null, 
      remove: false,
    };

    //views data 
    var data = {
      currStep : 0,
    };

    
    // eslint-disable-next-line no-undef
    let obj = content;

    console.log(obj);

    var steps = obj.steps;

    var feedbackArr = obj.asessment_page_feedback;


    setup();

    console.log(steps);

    $nextStep.on('click', function(e) {
      e.preventDefault();
      let $currStep = $(this).data('step');
      !$(this).hasClass('btn-disabled') && nextStep($currStep);
    });

    $prevStep.on('click', function(e) {
      e.preventDefault();
      let $currStep = $(this).data('step');
      prevStep($currStep);
    });

    $stepListItem.on('click', function(e){
      e.preventDefault();
      let $step = parseInt($(this).data('step'));
      !$(this).hasClass('disabled') && goToStep($step);
    });


    

    function setup() {
      bindPropsToView();
      setTimeout(() => $(document).trigger('resizeAssessmentContainer'), 1250);
      assessmentHasSliders() && (setUpSliders());
    }

    $(document).on('resizeAssessmentContainer', (e, delay = 0, extraHeight = 0) => resizeAssessmentContainer(delay, extraHeight));
    
    $(window).resize(() => $(document).trigger('resizeAssessmentContainer'));

    function resizeAssessmentContainer(delay = 0, extraHeight = 0) {
     setTimeout(() => {
       var $innerHeight = parseInt($container.find('.assessment-bar').outerHeight()) + parseInt($container.find('.assessment-loop').outerHeight());
        $innerHeight += typeof extraHeight === "number" ? extraHeight : 0;     
       $container.css('height', ($innerHeight + 'px'));  
     }, delay);
    }

    function setUpSliders() {
      $( ".emotion-slider" ).slider({
        min: 1,
        range: false,
        step: 1,
        max: 7,
        value: 1,
        animate:"slow",
        orientation: "horizontal",
        slide: function( event, ui ) {
            emotionSliderValidation(ui.value);
        },
      });
    }

    $('.emotion-image').on('click', function(e){
      e.preventDefault();
      var $val = $(this).data('num');  
      emotionSliderValidation($val);
    });

    $('.emotion-select__emotion').on('click', function(e) {
      e.preventDefault();
      var $el = $(this);
      var siblingsClassName = '.emotion-select__emotion';
      validate($el, siblingsClassName);
      console.log(steps);
    });

    $('.image-to-select').on('click', function(e){
      e.preventDefault();
      var $el = $(this);
      var siblingsClassName = '.image-to-select';
      validate($el, siblingsClassName);
      console.log(steps);
    });    

    function assessmentHasSliders() {
      var hasSlide = false;
      loopThruSteps(function(i) {
        if(steps[i].type == "slide") {
          hasSlide = true;
        }
      });
      return hasSlide;
    }


    function wipeUp(whilst, then, withDelay = 1000) {
      $('.assessment-step.active').find('.wipe-up').addClass('active');
      whilst();
      setTimeout(() => {
        then();  
      }, withDelay );
    }    

    function loopThruSteps(action) {
      for(var i = 0; i < steps.length; i++) {
        action(i);
      }
    }
    

    let assessmentStepElements = [
      '.assessment-step__conclusion__summary__h',
      '.assessment-step__conclusion__summary__img',
      '.assessment-step__conclusion__summary__p',
      '.assessment-step__conclusion__summary__li',
      '.image-to-select ',
      '.assessment-step__select h1',
      '.emotion-select > div[class^="col-"]',
      '.btn',
    ];


    /*
    function setNormalTransitionDelay() {
      return;
    }
    */

    let removeNormalTransition = () => assessmentStepElements.map(el => $(el).removeClass('normal-transition'));
    let addNormalTransition    = () => assessmentStepElements.map(el => $(el).addClass('normal-transition'));


   
    function assessmentStep() {
      return {
        onExit: () => {
          removeNormalTransition();
        },
        onEntry: () => {
          addNormalTransition();
        },
      };
    }
   

    function goToStep($step) {

      wipeUp(
        () => {
           assessmentStep().onExit();
           scrollTo('.container-assessment');  
        },
        () => {
          $('.assessment-step').removeClass('active');
          $('.assessment-step').removeClass('animate-in');
          $('.assessment-step').removeClass('animate-in__ajax');
          
          $('.assessment-step[data-id="' + $step + '"]').addClass('active');

          setTimeout(function() {
            $('.assessment-step[data-id="' + $step + '"]').addClass('animate-in');
          }, 150);

          $('.steps-list span').removeClass('active');
          $('.steps-list span[data-step="' + $step + '"]').addClass('active');


          data.currStep = $step;
          updateView("currStep");
          currStepObj = getCurrStep();
          checkStep();
          clearWipe();
          setTimeout(() => assessmentStep().onEntry(), 2000);
          $(document).trigger('resizeAssessmentContainer')


        }, 1250
      );
     
    }


    function clearWipe() {
      $('.assessment-step.active').find('.wipe-up').removeClass('active');
    }

    function scrollTo(selector, offset = 0) {
       if(selector) {
         $('html, body').animate({scrollTop:$(selector).offset().top + offset}, 450); 
       } else {
        return;
      }
    }  




    function checkStep() {
      if(data.currStep == 0) {
        $assessmentBar.addClass('hidden');
      } else {
        $assessmentBar.removeClass('hidden');
      }
    }


    function getCurrStep() {
      var stepObj;
      for(var i = 0; i < steps.length; i++) {
        if(steps[i].id == data.currStep) {
          stepObj = steps[i];
        }
      }
      return stepObj;
    }


    function currStepIsMultiSelect() {
      return currStepObj.multiselect == "yes" ? true : false;
    }



    function validate($el, siblingsClassName) {
      if(currStepIsMultiSelect()) {
        multiStepValidation($el);
      } else {
        singleStepValidation($el, siblingsClassName);
      } 

      updateCurrStepsWeight();
      isStepFinalised(); 


      if(allStepsFinalised()){
       doAssessment();
      }
    }
    $('.assessment-step__complete').on('click', function(){
      loadAssocTipSheets();
    });


    var uniqEs6 = (arrArg) => arrArg.filter((elem, pos, arr) => arr.indexOf(elem) == pos); 


    //gets all associatred tip sheets of highest weighted items
    function highestWeightedItemsTipSheets(removeDuplicates){
    if ( removeDuplicates === void 0 ) { removeDuplicates = true; }
      if(assessment.totalAssessmentWeight > 6){
        var idArr = [];
        getAssessmentItemsOfWorstWeighting().map(function (item) {
          idArr = idArr.concat( item.associated_tip_sheets);
        });
        return removeDuplicates ? uniqEs6(idArr) : idArr;
      } else {
        var currentLocation = window.location.href;
        if(currentLocation.includes("d3v.net.au") || currentLocation.includes("lndo.site")){
          return ['1412']; //PERMA For Good Mental Health Tipsheet in local server
        }else if(currentLocation.includes("com.au")){
          return ['1656']; //PERMA For Good Mental Health Tipsheet in live site
        }
      }
    }



    function loadAssocTipSheets() {

      let postFilter = new PostFilter({
        postType: 'post',
        postsPerPage: -1,
        categories: [],
        ajaxObj : obj,
        ajaxMethod: 'filter_tips_and_info_sheets',
        categoryNotIn: [],
        post__in: highestWeightedItemsTipSheets(),
      });

      $('.assessment-step__conclusion').removeClass('animate-in__ajax');

      postFilter.filter(
        () => {},
        (data) => {

          $('.assessment-step__conclusion__summary__h').html('Your results:');
          $('.assessment-step__conclusion__summary__p').html(assessment.feedbackMessage.content);
          $('.assessment-step__conclusion__summary__img').html('<img src="' + assessment.feedbackImage + '"/>');
          $('.assessment-step__conclusion__summary__li').html(function () {
            var markup = '';
            if(assessment.totalAssessmentWeight > 6){
                markup = '<p><strong>You have shown concerns in the following:</strong></p>';
                markup += '<ul>';
                getAssessmentItemsOfWorstWeighting().map(function (el) {
                  markup += '<li>' + el.subject_type + '</li>';
                });
                markup += '</ul>';
            }
            markup += '<h2>Here are some useful related tip sheets: </h2>';
            return markup;
          });
          $('.assessment-step__conclusion__tip-sheets').html(data);

          
          setTimeout(() => {
            $('.assessment-step__conclusion .wipe-up').removeClass('super-duper-active');
            $('.assessment-step__conclusion').addClass('animate-in__ajax');
            $('.blog-list__item').matchHeight(matchHeightOptions);
            $(document).trigger('resizeAssessmentContainer');
          }, 1250);
        } 
      );
    }



    let assessment = {
      averageWeight: null,
      highestWeightedItems: null,
      totalAssessmentWeight: null,
      feedbackMessage: null,
      feedbackImage: null,
    };



    function doAssessment() {
      
      assessment.averageWeight = getAssessmentAverageWeight();
      assessment.highestWeightedItems = getAssessmentItemsOfWorstWeighting();
      assessment.totalAssessmentWeight = getTotalAssessmentWeight();
      assessment.feedbackMessage = getAssessmentFeedbackMessage(assessment.totalAssessmentWeight);
      assessment.feedbackImage = getAssessmentFeedbackImage(assessment.totalAssessmentWeight);


      console.log(assessment)
    }

    function getTotalAssessmentWeight() {
     var totalWeight = 0;

     steps.map(step => {
      totalWeight += step.weighting;
     });
     
     return totalWeight;
    }

    

    //RETURNS THE HIGHEST WEIGHTING NUMBER
    let highestWeightedItem = () => steps.sort((x,y) => y.weighting - x.weighting)[0].weighting;

    //RETURNS THE ASSESSMENTS THAT HAVE THE HIGHEST WEIGHTING OF ASSESSMENT 
    let  getAssessmentItemsOfWorstWeighting = () => steps.filter((x) =>  x.weighting == highestWeightedItem());

    function getAssessmentAverageWeight() {
     
     var totalWeight = 0;
     let totalSteps = steps.length;

     steps.map(step => totalWeight += step.weighting);

     return totalWeight / totalSteps;

    }


    let range_6 = (score) =>  score <= 6;
    let range_7_10 = (score) =>  score >= 7 && score <= 10;
    let range_11_15 = (score) => score >= 11 && score <= 15;
    let range_16_20 = (score) => score >= 16 && score <= 20;

    function getAssessmentFeedbackImage(score){
      var img;
      switch(true) {
        case range_6(score):
          img = obj.emotion_img_array['happy'];
          break;
        case range_7_10(score):
          img = obj.emotion_img_array['neutral'];
          break;
        case range_11_15(score):
          img = obj.emotion_img_array['stressed'];
          break;
        case range_16_20(score):
          img = obj.emotion_img_array['unmotivated'];
          break;
      }
      return img;
    }

    function getAssessmentFeedbackMessage(score) {

      var feedback;


      switch(true) {
        case range_6(score): 
          feedback = feedbackArr[0];
          break;

        case range_7_10(score):
          feedback = feedbackArr[1];
          break;

        case range_11_15(score):
          feedback = feedbackArr[2];
          break;

        case range_16_20(score):
          feedback = feedbackArr[3];
          break;
      }

      return feedback;

    }

    function multiStepValidation($step) {
      let $i = $step.data('count');
      if(currStepObj.emotion_list[$i].is_selected == true) {
        $step.removeClass('active');
        currStepObj.emotion_list[$i].is_selected = false;
      } else {
        $step.addClass('active');
        currStepObj.emotion_list[$i].is_selected = true;
      }
    }




    function singleStepValidation($step, siblingsClassName) {
      let $i = $step.data('count');
      
      loopThruCurrentEmotionsList(function(i){
        $(siblingsClassName + '[data-count="' + i + '"]').removeClass('active');
        currStepObj.emotion_list[i].is_selected = false;
      });
      
      $step.addClass('active');
      currStepObj.emotion_list[$i].is_selected = true;   
      
    }

    function loopThruCurrentEmotionsList(action) {
      for (var i = 0; i < currStepObj.emotion_list.length; i++) {
        action(i);
      }
    }

    function emotionSliderValidation(val) {

      currStepObj.weighting = parseInt(val);
      
      $('.assessment-step.active .emotion-images .emotion-image').removeClass('active');
      loopThruCurrentEmotionsList(function(i) {
        currStepObj.emotion_list[i].is_selected = false;
      });

      currStepObj.emotion_list[(val - 1)].is_selected = true;
      $('.assessment-step.active .emotion-images .emotion-image[data-num="' + val + '"]').addClass('active');
      $('.assessment-step.active .emotion-slider').slider("value", val);

      isStepFinalised();
      console.log(currStepObj);

    }

    function checkAllNavSteps() {
      loopThruSteps(function(i) {
        if(stepHasWeighting(steps[i])) {
          $('.steps-list > span[data-step="'+(i + 1)+'"]').removeClass('disabled');
          $('.steps-list > span[data-step="'+(i + 1)+'"]').addClass('complete');

          //next step
          $('.steps-list > span[data-step="'+(i + 2)+'"]').removeClass('disabled');
          //console.log($('.steps-list > span[data-step="'+(i + 2)+'"]'));
          //console.log((i + 2) + 'should be clickable');

        } else {
          //$('.steps-list > span[data-step="'+(i + 1)+'"]').addClass('disabled');
          //$('.steps-list > span[data-step="'+(i + 1)+'"]').removeClass('complete');
          //next step
          //$('.steps-list > span[data-step="'+(i + 2)+'"]').addClass('disabled');
        }
      });
    }

    function isStepFinalised(){
      checkAllNavSteps();
      if(currentStepHasWeighting()) {
        $('.assessment-step.active .assessment-step-btn').removeClass('btn-disabled');
      } else {
        $('.assessment-step.active .assessment-step-btn').addClass('btn-disabled');
      }
    }

    function allStepsFinalised() {
      var allStepsFinalised = true;

      loopThruSteps((i) => {
        if(!stepHasWeighting(steps[i])){
          allStepsFinalised = false;
        }
      });

      return allStepsFinalised;

    }

    let currentStepHasWeighting = () => currStepObj.weighting !== null && currStepObj.weighting !== 0 && !isNaN(currStepObj.weighting);

    let stepHasWeighting = (specifiedStep) => specifiedStep.weighting !== null && specifiedStep.weighting !== 0 && !isNaN(specifiedStep.weighting);
    

    function updateCurrStepsWeight() {

      var avg = 0;
      var weight = 0;

      for(var i = 0; i < currStepObj.emotion_list.length; i++) {
        if(currStepObj.emotion_list[i].is_selected == true) { 

          if(currStepObj.emotion_list[i].hasOwnProperty('value')){
            weight += currStepObj.emotion_list[i].value
          } else {
            weight += (i + 1);  
          }

          avg += 1;
        }
      }

      var avgWeight = weight / avg;
      currStepObj.weighting = avgWeight;

      console.log(currStepObj)

    }


    //updates the view of specific object
    function updateView(objPropName) {
      var newData = data[objPropName];
      $('#' + objPropName).html(newData);
    }


    function nextStep($currStep) {
      goToStep(($currStep + 1));
      console.log(steps)
    }

    function prevStep($currStep) {
      goToStep(($currStep - 1));
    }


    //binds all data to view 
    function bindPropsToView() {
      for(var key in data) { 
        data.hasOwnProperty(key) ? updateView(key) : ''; 
      }
    }
    


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/assessment.js